
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/choosing-a-car",
      function () {
        return require("private-next-pages/guides/choosing-a-car/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/choosing-a-car"])
      });
    }
  